export default {
  path: '/2019VolunteerSelection',
  name: '2019VolunteerSelection',
  component: () => import('./Home.vue'),
  redirect: '/2019VolunteerSelection/Activities',
  meta: {
    title: '最美扶贫志愿者评选',
  },
  children: [
    {
      path: 'Activities',
      component: () => import('./Activities.vue'),
      name: '2019VolunteerSelection/Activities',
      meta: {
        title: '最美扶贫志愿者评选',
      },
    },
    {
      path: 'RelativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '2019VolunteerSelection/RelativeNews',
      meta: {
        title: '最美扶贫志愿者评选',
      },
    },
    {
      path: 'SelectRules',
      component: () => import('./SelectRules.vue'),
      name: '2019VolunteerSelection/SelectRules',
      meta: {
        title: '最美扶贫志愿者评选',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: '2019VolunteerSelection/DetailPage',
      meta: {
        title: '最美扶贫志愿者评选',
      },
    },
  ],
};
